import { render } from "./Section.vue?vue&type=template&id=ada49dd2"
import script from "./Section.vue?vue&type=script&lang=js"
export * from "./Section.vue?vue&type=script&lang=js"
script.render = render

export default script